
import React from "react";
import { SidebarLink } from "./SidebarLink";
import { SidebarLink as SidebarLinkType } from "./types";

interface SidebarLinksProps {
  links: SidebarLinkType[];
  collapsed: boolean;
  title?: string;
}

export const SidebarLinks: React.FC<SidebarLinksProps> = ({ links, collapsed, title }) => {
  if (links.length === 0) return null;
  
  return (
    <>
      {title && (
        <div className={`px-3 mb-2 ${collapsed ? 'hidden' : 'block'}`}>
          <div className={`h-px w-full bg-gradient-to-r from-transparent via-[#2A3749] to-transparent`}></div>
          <h3 className="text-xs uppercase text-gray-500 px-3 py-2">{title}</h3>
        </div>
      )}
      
      <div className="px-2 mb-4">
        {links.map((link) => (
          <SidebarLink key={link.to} link={link} collapsed={collapsed} />
        ))}
      </div>
    </>
  );
};

